import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/tx.jpg'


const _withScopeId = n => (_pushScopeId("data-v-74f00ce7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "aside__top" }
const _hoisted_3 = { class: "aside_left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "智学慧育平台")
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "menuList" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "aside_right" }
const _hoisted_10 = { class: "search-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-search search_icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link headPortrait" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import screenfull from "screenfull";
import { createRouter } from "vue-router";
import { TUserInfoType } from "@/module/login";
//import { menu, menuList } from "./../../hooks/nav"
import { dataInit } from '@/hooks/useDatabaseMenuFiltering'
import { TMenuType } from "@/module/database";
import bus from "@/utils/bus";
type TState = {
    keyword: string
    activeIndex: number
    menuList: Array<TMenuType>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'navTop',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useStore();
const state = reactive<TState>({
    activeIndex: 0, //导航索引
    keyword: '', //搜索课程关键词
    menuList: []
});


const { getFilterMenus } = dataInit()



onMounted(async () => {
    //获取左菜单数据
    let res = await getFilterMenus({ ParentId: 0 })
    const items = res[0]?.Children
    store.commit('setSecondLevelMenu', items)
    store.commit('setBannerUrl', res[0]?.PicUrl)
    state.menuList = res
})

const onClickLogo = () => {
    router.push({ path: "database" });
}

// 退出登录
const loginOut = () => {
    router.go(0);
    window.localStorage.clear();
    router.replace("/login");
};
const toMenu = (row: TMenuType, index: number) => {
    store.commit('setSecondLevelMenu', row?.Children)
    store.commit('setBannerUrl', row?.PicUrl)
    router.push({ path: "database" });
    state.activeIndex = index
};
const selectMoreMenu = (index: number) => {
    moreMenuList.map(item => item.isSelect = false)
    moreMenuList[index].isSelect = true
    if (moreMenuList[index].name === "退出登录") {
        loginOut()
    } else {
        router.replace({ path: moreMenuList[index].path, query: { menuTitle: moreMenuList[index].name } });
        isShowMoreMenu.value = false
    }
};
const onSearch = () => {
    bus.emit('eventName', state.keyword)
    router.push({ path: 'searchList', query: { keyword: state.keyword } })
}

// 页面刷新选中对应菜单


let isShowMoreMenu = ref(false);
// 点击头像后的更多菜单列表
const moreMenuList = reactive([{
    id: 1,
    name: '个人信息',
    path: "/personalInformation",
    isSelect: false
}, {
    id: 2,
    name: '我的收藏',
    path: "/myCollect",
    isSelect: false
}, {
    id: 5,
    name: '退出登录',
    path: "",
    isSelect: false
}]);
watch(() => route.query.menuTitle, (newVal, oldVal) => {
    moreMenuList.map(item => {
        item.isSelect = false
        if (item.name === newVal) {
            item.isSelect = true
        }
    })
}, { immediate: true })




return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "projectTitle",
          onClick: onClickLogo
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.menuList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['menuItem',{active:state.activeIndex===index}]),
              key: index,
              onClick: ($event: any) => (toMenu(item,index))
            }, _toDisplayString(item.Name), 11, _hoisted_8))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_input, {
            modelValue: state.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.keyword) = $event)),
            placeholder: "搜索关键词",
            class: "search_input",
            onKeyup: _withKeys(onSearch, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"]),
          _createElementVNode("div", {
            class: "search_btn",
            onClick: onSearch
          }, "搜索")
        ]),
        _createVNode(_component_el_dropdown, {
          "hide-on-click": false,
          class: "moreMenu",
          trigger: "click",
          placement: "top"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreMenuList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    onClick: ($event: any) => (selectMoreMenu(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})